import React, { createContext, useState } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUserState] = useState(() => {
    const saved = localStorage.getItem("user");
    return saved ? JSON.parse(saved) : null;
  });

  const setUser = (userData) => {
    if (userData) {
      localStorage.setItem("user", JSON.stringify(userData));
    } else {
      localStorage.removeItem("user");
    }
    setUserState(userData);
  };

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;

// Helpers — read from the stored user object
// 2026-10-23 fix (clinician invite-only build, Piece 6) — isPatientUser
// used to mean "not a clinician," which silently treated any THIRD role
// (now sales_rep) as a patient too. Exact match on "patient" only — the
// server always sends an explicit role (Login.js defaults it to
// "patient" if the backend ever omitted one), so this never needs a
// loose/fallback comparison.
export const isPatientUser  = (user) => !!user && user.role === "patient";
export const isClinicianUser = (user) => user?.role === "clinician";
export const isSalesRepUser = (user) => user?.role === "sales_rep";